module.exports = __webpack_public_path__ + "img/phone2.451af5ea.png";